import React, { useEffect } from 'react';
import { Route, Redirect } from "react-router-dom";
import { loadState, saveState } from "./localStorage";
import { localStorageName } from "./localStorageData";
import { useSelector, useDispatch } from 'react-redux';
import { deleteState, insertNewState } from 'redux/slicers/kingdomOV3Slice';

const useProtectedRoutes = () => {

    //////////////////////////// Obtención de los valores del estado global
    const infoUsuario = useSelector((state) => state.kingdomOV3.infoUsuario);
    const procedimientoActual = useSelector((state) => state.kingdomOV3.procedimientoActual);
    const convocatoriaSeleccionada = useSelector((state) => state.kingdomOV3.convocatoriaSeleccionada);
    const loginOut = useSelector((state) => state.kingdomOV3.loginOut);

    const dispatch = useDispatch();

    //////////////////////////// OBJETO PARA EL COMPONENTE CONFIRMACION (INCLUIDO EN ListadoProcedimientos)
    const objDataPopup = {
        titulo: 'Redirección',
        mensaje: 'Ha sido redireccionado a la página principal de la aplicación. No está permitida la navegación directa por URL y la actualización de la página.'
    };
    
    //Funcion para controlar el evento beforeunload
    const handleBeforeUnload = (event) => {
        
    const isMiniApplet = localStorage.getItem(localStorageName.popUp);

    if (isMiniApplet === undefined || isMiniApplet === null){
        //Prevenimos el comportamiento predeterminado del evento
        event.preventDefault();
        localStorage.removeItem(localStorageName.popUp);
    } else {
        return ; 
    }
};

    
    useEffect(() => {
        // Agrega el evento beforeunload al objeto window
        window.addEventListener('beforeunload', handleBeforeUnload);
    }, []);
    
    /**
     * @function inicializarCondiciones Función que inicializa las condiciones obtenidas que condicionan el acceso a las pantallas de la aplicación
     * @returns Objeto que contiene las condiciones de cada pantalla.
     * IMPORTANTE: El nombre de la key es el valor de la path que recibe el objeto ProtectedRoute a excepción de la /
     * Ej.: Si la path es /MenuNavegacion, se extrae la / y quedaría MenuNavegacion
     */
    const inicializarCondiciones = () => {

        // Paso 1. Se obtienen los valores del localstorage        
        let username = loadState(localStorageName.username, false);


        // Paso 2. Se definen las condiciones para cada pantalla

        /**
         * @constant loggedUser Constante que indica si el usuario está logado.
         * Al logarse el usuario en la aplicación se crea un nuevo valor (infoUsuario)
         * en el estado global e inserta información referente al usuario.
         * Se tiene en cuenta si se ha cerrado sesión estando en cualquier otra parte
         * de la aplicación, para evitar que se lance el mensaje de redireccionamiento.
         */
        const loggedUser = (infoUsuario === undefined || infoUsuario === '') && loginOut === undefined;

        /**
         * @constant loggedAdminUser Constante que indica si se ha logado un usuario Administrador.
         * Al logarse un usuario administrador, el valor username aparecerá informado con su DNI.
         * Se tiene en cuenta si se ha cerrado sesión estando en cualquier otra parte
         * de la aplicación, para evitar que se lance el mensaje de redireccionamiento.
         */
        const loggedAdminUser = loginOut === undefined && username === undefined || (username === 'aplicacion' || username === 'ciudadano');

        /**
         * @constant accessToApp Constante que indica si se puede acceder a la aplicación una vez se ha pasado la
         * pantalla de selección de convocatoria.
         */
        const accessToApp = loggedUser || (procedimientoActual === undefined || procedimientoActual === '') || convocatoriaSeleccionada === undefined;

        // Paso 3. Se devuelve un objeto con las condiciones para cada pantalla

        return {
            LoginAdministrador: loggedUser,
            MenuNavegacion: loggedAdminUser,
            ListadoFormularios: loggedAdminUser,
            CreacionFormularios: loggedAdminUser,
            BandejaSolicitudes: accessToApp,
            NuevaSolicitud: accessToApp,
            AporteDocumentacion: accessToApp,
            FirmaSolicitud: accessToApp,
            SolicitudPresentadaCorrectamente: accessToApp,
            HistoricoDocumentos: accessToApp,
            Desistimiento: accessToApp,
            AltaAnexo: accessToApp,
            AltaEntidadColaboradora: accessToApp
        }
    }

    //////////////////////////// FUNCIONES

    /**
     * @function ProtectedRoute Función que en caso de que se cumpla una serie de condiciones redijirá hacia
     * el home de la aplicación, en caso contrario continuará la navegación
     * @param {*} param recibe el componente y la path (ruta) de este
     * @returns Devuelve la redirección en caso de que se cumpla las condiciones o la ruta del componente en
     * caso de que no se cumplan las condiciones
     */
    const ProtectedRoute = ({ component: Component, path }) => {
        // Paso 1. Se inicializan las condiciones
        let condiciones = inicializarCondiciones();

        /* Paso 2. Obtención de la key de la condición.
         * Para obtenter la condición, se aprovecha el nombre de la path y se quita el primer caracter (/).
         * Ej.: Si el path es /MenuNavegacion, se recorta la /.
        */
        let condicion = path.substring(1, path.length);
        let res = null;
        
        /* Paso 3. Acceso a la pantalla solicitada o redireccionamiento al home de la aplicación.
         * Si se cumple la condición se redireccionará al home de la aplicación, de lo contrario se navegará a la pantalla indicada.
        */
        if (condiciones[condicion]) {
            // Se almacena para mostrar en el listado de procedimientos un popup informando del redireccionamiento
            dispatch(insertNewState({filnedName: 'protectedRoute', value: true}));
            res = <Redirect to='/' />
        } else {
            loginOut && dispatch(deleteState({filnedName: 'loginOut'}));
            res = <Route path={path} exact component={Component} />;
        }
        return res;
    }
    return { ProtectedRoute, objDataPopup };
}

export default useProtectedRoutes;